<!--
 * @Author: Gaho
 * @Date: 2024-06-24 14:27:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-10 16:11:03
 * @Description: 
-->
<template>
    <div 
        class="px-[10px] date-picker rounded-lg cursor-pointer relative"
        ref="dataPicker"
    >
        <div 
            class="date-select" 
            @click="showClander = !showClander;" 
        >
            <span class="calendar-icon">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M18.33 8.6v7.07c0 1.77-.92 2.66-2.77 2.66H4.44c-1.85 0-2.77-.89-2.77-2.66V8.6c0-.15.12-.27.27-.27h16.12c.15 0 .27.12.27.27Zm-2.77-4.93H14.4V2.33a.69.69 0 0 0-.7-.66c-.38 0-.7.3-.7.66v1.34H7V2.33a.69.69 0 0 0-.7-.66c-.38 0-.7.3-.7.66v1.34H4.44c-1.85 0-2.77.89-2.77 2.66v.4c0 .15.12.27.27.27h16.12c.15 0 .27-.12.27-.27v-.4c0-1.77-.92-2.66-2.77-2.66Z"></path>
                </svg>
            </span>
            <div class="input-box flex items-center justify-between flex-nowrap">
                <Input :modelValue="formatDate(new Date(modelValue.from))"></Input>
                -
                <Input :modelValue="formatDate(new Date(modelValue.to))"></Input>
            </div>
            <span class="arrow-icon" :class="[showClander ? 'rotate-180' : '']">
                <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.540023 2.62878C0.928956 2.23667 1.56212 2.2341 1.95423 2.62303L5 5.64413L8.04577 2.62303C8.43788 2.2341 9.07104 2.23667 9.45998 2.62878C9.84891 3.02089 9.84633 3.65405 9.45422 4.04298L6.3671 7.1051C5.61266 7.85342 4.38734 7.85342 3.6329 7.1051L0.545775 4.04298C0.153666 3.65405 0.15109 3.02089 0.540023 2.62878Z" fill="currentColor"></path>
                </svg>
            </span>
        </div>
        <!-- 
            ↓ 弹出的日历 
        -->
        <div v-if="showClander"
            class="absolute top-[46px] left-0 z-[99]"
        >
            <q-date
                model-value="modelValue"
                range
                minimal
                @update:model-value="(value, reason, details) => handleUpdate(value, reason, details)"
                :locale="locale"
                :options="disableDate"
                class="date-range"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import 'quasar/src/components/date/QDate.sass'; 

const props = defineProps({
    modelValue: {
        type: Object,
        default: () => {},
    },
});
const showClander = ref(false);
const dataPicker = ref(null);
const emit = defineEmits(['update:modelValue']);
const locale = computed(() => {
    if (useI18n().locale.value == 'cn'){
        return oQdateLocale;
    }
    return void 0;
});

/**
 * 设置禁止日期
 * @param date 日期
 */
const disableDate = (date) => {
    return new Date(date) <= new Date();
};
const handleUpdate = (value, reason, details) => {
    emit('update:modelValue', value, reason, details);
    showClander.value = false;
}
/**
 * 点击空白处关闭日历弹框
 * @param e 
 */
const handleClick = (e) => {
    if (showClander.value && dataPicker.value){
        if (!dataPicker.value.contains(e.target)){
            showClander.value =!showClander.value;
        }
    }
}
/**
 * 格式化日期格式
 */
const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
    const year = date.getFullYear();
    // console.log('语言：', useI18n().locale.value);
    if (useI18n().locale.value == 'cn'){
        return `${year}/${month}/${day}`; 
    }
    return `${day}/${month}/${year}`;
}

onMounted(() => {
    document.addEventListener('click', handleClick);
});
onUnmounted(() => {
    document.removeEventListener('click', handleClick);
});
</script>

<style lang="scss" scoped>
.date-picker {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1c2532;
    .date-select {
        display: flex;
        align-items: center;
        justify-content: space-between;
        svg {
            color: #55657e;
        }
        .calendar-icon {
            font-size: 20px;
            width: 20px;
            height: 20px;
        }
        .arrow-icon {
            font-size: 10px;
            width: 16px;
            height: 16px;
        }
        .input-box {
            font-size: 11px;
            font-weight: 600;
            >:deep(div) {
                background: transparent !important;
                border: 0 !important;
                width: 78px;
                font-size: 11px;
            }
        }
    }
    .date-range {
        background: #0f172a;
        border: 1px solid #334155;
    }
}

</style>